<div class="text tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.text' | translate }}
    </h5>
    <div class="font-family-container tool-list">
        <div class="font-family" [class.show]="fontFamilyDropdownShow" (click)="fontFamilyDropDownClick($event)">
            <div class="text-container">
                {{ fontFamily }}
            </div>
            <mat-icon class="dropdown-icon" [class.show]="fontFamilyDropdownShow" svgIcon="arrow-down"></mat-icon>
        </div>
        <ul class="item-list" [class.show]="fontFamilyDropdownShow">
            <li
                class="font-family-item"
                [class.select]="fontFamily === fontFamilyItem"
                (click)="fontFamilyItemClick(fontFamilyItem)"
                *ngFor="let fontFamilyItem of FONT_FAMILY_LIST; index as i">
                <span>{{ fontFamilyItem }}</span>
            </li>
        </ul>
    </div>
    <div class="input-container">
        <app-editor-input-text
            name="fontSize"
            label="mimic.design.text.label.font-size"
            [value]="fontSize"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handleSizeChange($event)"
            (onInputKeyDown)="validFontSizeKeyDown($event)">
        </app-editor-input-text>
        <app-editor-input-text
            name="angle"
            label="mimic.design.text.label.letter-spacing"
            [value]="letterSpacing"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handleSpacingChange($event)"
            (onInputKeyDown)="validSpacingKeyDown($event)">
        </app-editor-input-text>
    </div>
</div>
